import React, { Component } from 'react';
import HeaderTitle from '../../../GeneralComponents/HeaderTitle';
import Loading from '../../../GeneralComponents/LoadingComponen';

const RISK_CONFIG = {
    high:   { label: 'ALTO',   bg: '#fee2e2', color: '#dc2626', dot: '#dc2626' },
    medium: { label: 'MEDIO',  bg: '#fef3c7', color: '#d97706', dot: '#d97706' },
    low:    { label: 'BAJO',   bg: '#dbeafe', color: '#2563eb', dot: '#2563eb' },
    none:   { label: 'LIMPIO', bg: '#d1fae5', color: '#059669', dot: '#059669' },
};

const S = {
    page:       { fontFamily: '"Inter","Segoe UI",system-ui,sans-serif', color: '#0f172a' },
    toolbar:    { background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10, padding: '14px 16px', marginBottom: 14, boxShadow: '0 1px 4px rgba(15,23,42,0.05)', display: 'flex', flexDirection: 'column', gap: 10 },
    filterRow:  { display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' },
    actionRow:  { display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' },
    input:      { border: '1px solid #cbd5e1', borderRadius: 7, padding: '8px 12px', fontSize: 13, outline: 'none', color: '#0f172a', flex: '1 1 140px', minWidth: 0 },
    select:     { border: '1px solid #cbd5e1', borderRadius: 7, padding: '8px 10px', fontSize: 13, color: '#475569', background: '#fff', flex: '1 1 140px', minWidth: 0 },
    btnPrimary: { background: '#1e3a6e', color: '#fff', border: 'none', borderRadius: 7, padding: '8px 18px', fontSize: 13, fontWeight: 600, cursor: 'pointer', flex: '0 0 auto' },
    btnGhost:   { background: 'transparent', color: '#64748b', border: '1px solid #e2e8f0', borderRadius: 7, padding: '8px 14px', fontSize: 13, cursor: 'pointer', flex: '0 0 auto' },
    btnNew:     { fontSize: 13, fontWeight: 600, color: '#fff', background: '#059669', border: 'none', borderRadius: 7, padding: '8px 16px', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 6, flex: '0 0 auto', whiteSpace: 'nowrap' },
    card:       { background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10, boxShadow: '0 1px 4px rgba(15,23,42,0.05)', overflow: 'hidden' },
    tableWrap:  { overflowX: 'auto' },
    table:      { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
    th:         { padding: '10px 14px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: '#475569', borderBottom: '2px solid #e2e8f0', background: '#f8fafc', textTransform: 'uppercase', letterSpacing: '0.04em', whiteSpace: 'nowrap' },
    td:         { padding: '10px 14px', borderBottom: '1px solid #f1f5f9', verticalAlign: 'middle', color: '#0f172a' },
    tdMuted:    { padding: '10px 14px', borderBottom: '1px solid #f1f5f9', verticalAlign: 'middle', color: '#64748b', fontSize: 12 },
    riskBadge:  (level) => {
        const r = RISK_CONFIG[level] || RISK_CONFIG.none;
        return { display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 11, fontWeight: 700, color: r.color, background: r.bg, borderRadius: 20, padding: '2px 9px' };
    },
    dot:        (color) => ({ width: 6, height: 6, borderRadius: '50%', background: color, flexShrink: 0 }),
    matchCount: { display: 'inline-block', fontSize: 12, fontWeight: 700, color: '#1e3a6e', background: '#eff6ff', borderRadius: 4, padding: '1px 7px' },
    pdfBtn:     { fontSize: 11, fontWeight: 600, color: '#c0392b', background: '#fdf2f2', border: '1px solid #fca5a5', borderRadius: 5, padding: '3px 10px', cursor: 'pointer', textDecoration: 'none' },
    noPdf:      { fontSize: 11, color: '#94a3b8' },
    pagination: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 20px', borderTop: '1px solid #e2e8f0', flexWrap: 'wrap', gap: 8 },
    pageMeta:   { fontSize: 12, color: '#64748b' },
    pagebtns:   { display: 'flex', gap: 6 },
    pageBtn:    (active) => ({
        fontSize: 12, fontWeight: active ? 700 : 400,
        color: active ? '#fff' : '#475569',
        background: active ? '#1e3a6e' : '#f8fafc',
        border: '1px solid ' + (active ? '#1e3a6e' : '#e2e8f0'),
        borderRadius: 5, padding: '4px 10px', cursor: 'pointer'
    }),
    emptyState: { padding: '48px', textAlign: 'center', color: '#94a3b8' },
};

class Index extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            queries: [],
            meta: { total: 0, page: 1, per_page: 50, total_pages: 1 },
            isLoading: true,
            q: '',
            risk_level: '',
            date_from: '',
            date_to: '',
        };
    }

    componentDidMount() { this.fetchData(); }

    fetchData = (page = 1) => {
        const { q, risk_level, date_from, date_to, meta } = this.state;
        const per_page = meta.per_page;
        const params = new URLSearchParams({ page, per_page });
        if (q)          params.append('q', q);
        if (risk_level) params.append('risk_level', risk_level);
        if (date_from)  params.append('date_from', date_from);
        if (date_to)    params.append('date_to', date_to);

        this.setState({ isLoading: true });
        fetch(`/sarlaft-listas/historial/data?${params}`, {
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        })
        .then(r => r.json())
        .then(data => this.setState({ queries: data.queries || [], meta: data.meta || this.state.meta, isLoading: false }))
        .catch(() => this.setState({ isLoading: false }));
    }

    handleFilter = (e) => { e.preventDefault(); this.fetchData(1); }
    handleClear  = () => { this.setState({ q: '', risk_level: '', date_from: '', date_to: '' }, () => this.fetchData(1)); }

    renderRisk(level) {
        const r = RISK_CONFIG[level] || RISK_CONFIG.none;
        return (
            <span style={S.riskBadge(level)}>
                <span style={S.dot(r.dot)}></span>
                {r.label}
            </span>
        );
    }

    renderPagination() {
        const { meta } = this.state;
        if (meta.total_pages <= 1) return null;
        const pages = [];
        const start = Math.max(1, meta.page - 2);
        const end   = Math.min(meta.total_pages, meta.page + 2);
        for (let i = start; i <= end; i++) pages.push(i);
        return (
            <div style={S.pagination}>
                <span style={S.pageMeta}>
                    {meta.total} consultas · página {meta.page} de {meta.total_pages}
                </span>
                <div style={S.pagebtns}>
                    {meta.page > 1 && <button style={S.pageBtn(false)} onClick={() => this.fetchData(meta.page - 1)}>‹</button>}
                    {pages.map(p => <button key={p} style={S.pageBtn(p === meta.page)} onClick={() => this.fetchData(p)}>{p}</button>)}
                    {meta.page < meta.total_pages && <button style={S.pageBtn(false)} onClick={() => this.fetchData(meta.page + 1)}>›</button>}
                </div>
            </div>
        );
    }

    render() {
        const { queries, meta, isLoading, q, risk_level, date_from, date_to } = this.state;
        return (
            <React.Fragment>
                <HeaderTitle
                    title="Historial de Consultas SARLAFT"
                    subTitle="Registro de todas las consultas realizadas"
                    icon="fas fa-history"
                    showNew={false}
                    showFilter={false}
                    is_index={true}
                    url={this.props.current_url}
                />
                <div style={S.page}>
                    {/* Toolbar filtros */}
                    <form onSubmit={this.handleFilter} style={S.toolbar}>
                        <div style={S.filterRow}>
                            <input style={{ ...S.input, flex: '2 1 200px' }} placeholder="Buscar nombre, ID, usuario..." value={q} onChange={e => this.setState({ q: e.target.value })} />
                            <select style={S.select} value={risk_level} onChange={e => this.setState({ risk_level: e.target.value })}>
                                <option value="">Todos los niveles</option>
                                <option value="high">Alto</option>
                                <option value="medium">Medio</option>
                                <option value="low">Bajo</option>
                                <option value="none">Sin coincidencias</option>
                            </select>
                            <input style={S.input} type="date" value={date_from} onChange={e => this.setState({ date_from: e.target.value })} title="Desde" />
                            <input style={S.input} type="date" value={date_to}   onChange={e => this.setState({ date_to: e.target.value })}   title="Hasta" />
                        </div>
                        <div style={S.actionRow}>
                            <button type="submit" style={S.btnPrimary}><i className="fas fa-search" style={{ marginRight: 6 }}></i>Filtrar</button>
                            <button type="button" style={S.btnGhost} onClick={this.handleClear}>Limpiar</button>
                            <span style={{ fontSize: 12, color: '#94a3b8', marginLeft: 'auto' }}>{meta.total} resultados</span>
                            <a href="/sarlaft-listas" style={S.btnNew}>
                                <i className="fas fa-plus"></i> Nueva consulta
                            </a>
                        </div>
                    </form>

                    {/* Tabla */}
                    <div style={S.card}>
                        {isLoading ? <Loading /> : (
                            <>
                                <div style={S.tableWrap}>
                                    <table style={S.table}>
                                        <thead>
                                            <tr>
                                                <th style={S.th}>Fecha / Hora</th>
                                                <th style={S.th}>Usuario</th>
                                                <th style={S.th}>Nombre consultado</th>
                                                <th style={S.th}>Identificacion</th>
                                                <th style={S.th}>Nivel riesgo</th>
                                                <th style={{ ...S.th, textAlign: 'center' }}>Coincidencias</th>
                                                <th style={S.th}>Fuentes</th>
                                                <th style={{ ...S.th, textAlign: 'center' }}>PDF</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {queries.length === 0 ? (
                                                <tr><td colSpan={8} style={S.emptyState}>No hay consultas registradas.</td></tr>
                                            ) : queries.map(q => (
                                                <tr key={q.id} style={{ transition: 'background .1s' }}
                                                    onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                                                    onMouseLeave={e => e.currentTarget.style.background = ''}>
                                                    <td style={S.tdMuted}>
                                                        <div style={{ fontWeight: 600, color: '#334155', fontSize: 12 }}>{q.searched_at}</div>
                                                        <div style={{ fontSize: 10, color: '#94a3b8', marginTop: 1 }}>#{q.verification_code}</div>
                                                    </td>
                                                    <td style={S.td}>
                                                        <div style={{ fontWeight: 600, fontSize: 12 }}>{q.user_name || '—'}</div>
                                                        <div style={{ fontSize: 11, color: '#94a3b8' }}>{q.user_email}</div>
                                                    </td>
                                                    <td style={S.td}>{q.search_query || <span style={{ color: '#94a3b8' }}>—</span>}</td>
                                                    <td style={{ ...S.td, fontFamily: 'monospace', fontSize: 12 }}>{q.search_identifier || <span style={{ color: '#94a3b8' }}>—</span>}</td>
                                                    <td style={S.td}>{this.renderRisk(q.risk_level)}</td>
                                                    <td style={{ ...S.td, textAlign: 'center' }}>
                                                        <span style={S.matchCount}>{q.total_matches}</span>
                                                    </td>
                                                    <td style={S.tdMuted}>
                                                        <div style={{ fontSize: 11, maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={(q.sources_checked || []).join(', ')}>
                                                            {(q.sources_checked || []).join(', ') || '—'}
                                                        </div>
                                                    </td>
                                                    <td style={{ ...S.td, textAlign: 'center' }}>
                                                        {q.has_pdf ? (
                                                            <a href={`/sarlaft-listas/historial/${q.id}/pdf`} target="_blank" style={S.pdfBtn} rel="noreferrer">
                                                                <i className="fas fa-file-pdf" style={{ marginRight: 4 }}></i>PDF
                                                            </a>
                                                        ) : <span style={S.noPdf}>—</span>}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                {this.renderPagination()}
                            </>
                        )}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Index;
